<template>
  <div :class="{'landscape-block': isLandscapeOnMobile}">
    <vue-progress-bar />
    <ControlerLayersMTK
      v-if="!showWeatherMtk && !isRoutingActive && !isLandscapeOnMobile"
      class="layer-picker"
      :showPanel.sync="isLayerPickerOpen"
      :selectedType="selectedBaseType"
      :activeOverlays="activeOverlays"
      :overlaysOpen.sync="layerOverlaysOpen"
      :weatherOpen.sync="layerWeatherOpen"
      @selectType="onSelectBaseType"
      @toggleOverlay="onToggleOverlay"
    />

    <div id="lhs_wrapper" v-if="!isLandscapeOnMobile">
      <keep-alive>
        <!-- <router-view /> -->
        <router-view @select-poi="openPoiFromEvent" />
      </keep-alive>
    </div>

    <div id="bottom-bar">
      <div id="company-links">
        <a href="https://www.schubert-franzke.com" target="_blank">
          <img class="company-logo" src="../assets/icons/sf_logo.png" alt="" />
        </a>
        <ImprintLinks />
      </div>
      <div id="scale-bar" v-if="!showWeatherMtk"></div>
      <!-- <div id="imprint"></div> -->
    </div>

    <SettingButtonsComponent
      v-if="!isRoutingActive && !isLandscapeOnMobile"
      @openWeatherMTK="openWeatherMTK"
      @toggleWeatherLayer="handleToggleWeather"
      @forceCloseWeather="onForceCloseWeather"
      @forceClose3D="onForceClose3D"
      @openMap3DView="openMap3DView"
      @clearRouting="clearRouting"
      @triggerGeolocationIn3D="onTriggerGeolocation"
      @switchToMapLibre2D="switchMapLibreTo2D"
      :isWeatherActive="weatherLayerActive"
      :is3DActive="showWeatherMtk"
      :isRoutingActive="isRoutingActive"
    />

    <PrintOverlay
      v-if="!isLandscapeOnMobile && $root.$data.printMode"
      :isMtkActive="showWeatherMtk"
      :getMtkSnapshot="getMtkSnapshot"
      :getPrintUrl="getPrintUrl"
    />
    <!-- <PrintOverlay 
    v-if="$root.$data.printMode" /> -->

    <div id="hover-popup"></div>
    <ul id="cluster-popup"></ul>
    <!-- <div id="map" v-show="!showMap3D" @contextmenu.prevent="$refs.menu.open" @contextmenu="setCoordinates" /> -->
    <div id="map" v-show="!showWeatherMtk" @contextmenu.prevent="$refs.menu.open" @contextmenu="setCoordinates" />

    <vue-context ref="menu" v-if="!$root.$data.embedded" :close-on-click="false" :lazy="true">
      <div class="coords">
        <p>{{ googleCoords }}</p>
        <i class="material-icons-round copy" @click.prevent="copyCoordinates">copy</i>
      </div>
      <!-- <li @click.prevent="setStartpoint">
        <img src="../assets/icons/marker.png" alt="" />
        <a>{{ $t("rightClickFrame.startPoint") }}</a>
      </li>
      <li @click.prevent="setEndpoint">
        <img src="../assets/icons/marker.png" alt="" />
        <a>{{ $t("rightClickFrame.endPoint") }}</a>
      </li> -->
      <li @click.prevent="getNearestPoi">
        <img src="../assets/icons/location.png" alt="" />
        <a>{{ $t("rightClickFrame.whatIsHere") }}</a>
      </li>
      <li @click.prevent="togglePrintMode">
        <img src="../assets/icons/print.png" alt="" />
        <a>{{ $t("rightClickFrame.print") }}</a>
      </li>
      <li @click.prevent="goToMeasure">
        <img src="../assets/icons/ruler-pencil.png" alt="" />
        <a>{{ $t("rightClickFrame.measure") }}</a>
      </li>
    </vue-context>

    <RoutingPanel
      ref="routing"
      @startSelected="onStart"
      @endSelected="onEnd"
      @setMode="onModeChanged"
      @calculate="triggerCounter++"
      @close="clearRouting"
    />
    <MenuPopup
      v-if="!isLandscapeOnMobile && routingLat && routingLng && routingZoom"
      :initialLat="routingLat"
      :initialLng="routingLng"
      :initialZoom="routingZoom"
      :routingStart="routingStart"
      :routingEnd="routingEnd"
      :routingMode="routingMode"
      :triggerCalculation="triggerCounter"
      @routingStatus="handleRoutingStatus"
    />
    <WeatherMTK
      ref="weatherMtk"
      v-if="showWeatherMtk"
      :lat="weatherLat"
      :lng="weatherLng"
      :zoom="weatherZoom"
      :visible="showWeatherMtk"
      :poisGeoJSON="poisFor3D"
      @poi-click="onPoiFrom3D"
      :startWithWeather="startWeatherWithLayer"
      :hideUi="isLandscapeOnMobile"
      @updateView="onWeatherMapMoved"
      @close3D="onWeatherMapClosed"
      @closeWeather="onWeatherLayerClosed"
      @updateWeatherState="weatherLayerActive = $event"
    >
      <template #controls>
        <SettingButtonsComponent
          @openWeatherMTK="openWeatherMTK"
          @forceCloseWeather="handleToggleWeather"
          @toggleWeatherLayer="handleToggleWeather"
          @openMap3DView="openMap3DView"
          @forceClose3D="handleToggle3D"
          @clearRouting="clearRouting"
          @triggerGeolocationIn3D="onTriggerGeolocation"
          :isWeatherActive="weatherLayerActive"
          :is3DActive="showMap3D"
          :isRoutingActive="false"
        />
      </template>
    </WeatherMTK>
    <RoutingMTK
      v-if="!isLandscapeOnMobile && routingStart && routingEnd"
      @routingStatus="handleRoutingStatus"
      :start="routingStart"
      :end="routingEnd"
      :mode="routingMode"
      :calculate="triggerCounter"
      :selecting="currentSelecting"
      :initialLat="routingLat"
      :initialLng="routingLng"
      :initialZoom="routingZoom"
      @routeCalculated="handleRouteCalculated"
    />
    <MapRoutingMTK
      v-if="!isLandscapeOnMobile && routingStart && routingEnd"
      :start="routingStart"
      :end="routingEnd"
      :mode="routingMode"
      :initialLat="routingLat"
      :initialLng="routingLng"
      :initialZoom="routingZoom"
      :triggerCalculation="triggerCounter"
      :selecting="currentSelecting"
      :hideControls="true"
      :isRouting="isRouting"
      @routeCalculated="handleRouteCalculated"
      @mapClicked="handleMapClick"
      @update:selecting="selecting = $event"
    >
      <template #controls>
        <SettingButtonsComponent :isRoutingActive="true" v-if="!isLandscapeOnMobile" />
      </template>
    </MapRoutingMTK>
    <div :class="{'landscape-block': isLandscapeOnMobile}">
      <div v-if="isLandscapeOnMobile" class="rotate-overlay">
        <div class="rotate-box">
          <span class="material-icons-round rotate-icon">screen_rotation</span>
          <p>{{ $t("rotateOverlay.message") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueContext from "vue-context";
import "vue-context/src/sass/vue-context.scss";
import {basemap} from "@/services/map/basemap";
import SettingButtonsComponent from "./button_controls/SettingButtons";
import M2wApi from "@/services/m2w_api";
import PrintOverlay from "@/components/PrintOverlay";
import {googleMaps} from "@/services/map/googleMaps";
import ImprintLinks from "@/components/page_elements/ImprintLinks";
import ZIndex from "@/services/zindex";
import Clipboard from "@/services/clipboard";
import WeatherMTK from "@/components/WeatherMTK.vue";
import MapRoutingMTK from "@/components/MapRoutingMTK.vue";
import ControlerLayersMTK from "@/components/ControlerLayersMTK.vue";

export default {
  name: "MapComponent",
  components: {
    ImprintLinks,
    PrintOverlay,
    VueContext,
    SettingButtonsComponent,
    WeatherMTK,
    MapRoutingMTK,
    ControlerLayersMTK,
  },
  watch: {
    routingStart: "updateRoutingState",
    routingEnd: "updateRoutingState",
    map3dLat(val) {
      console.log("map3dLat updated:", val);
    },
    // weatherLat(val) {
    //   console.log("weatherLat updated:", val);
    // },
    triggerCalculation() {
      console.log("[Map3DMTK] triggerCalculation changed:", this.triggerCalculation);

      if (this.start && this.end) {
        console.log("Map3DMTK] Calling calculateRouteFromPanel...");
        this.calculateRouteFromPanel(this.start, this.end, this.mode);
      } else {
        console.warn("[Map3DMTK] Start or end is missing:", this.start, this.end);
      }
    },

    //   $route: {
    //   immediate: true,
    //   handler(to, from) {
    //     if (from) {
    //       const changed = [];
    //       const keys = new Set([...Object.keys(from.query || {}), ...Object.keys(to.query || {})]);
    //       for (const k of keys) {
    //         if ((from.query?.[k] || '') !== (to.query?.[k] || '')) changed.push(k);
    //       }
    //       const onlyLocationChanged = changed.length === 1 && changed[0] === 'location';
    //       if (onlyLocationChanged) {
    //         // DOAR ?location s-a schimbat din mișcarea hărții → nu mai restaura la initialView
    //         this.fetchSinglePoiAndOpenFromRoute(); // dacă ai nevoie
    //         return;
    //       }
    //     }

    //     this.fetchSinglePoiAndOpenFromRoute();

    //     if (this.isMainPanel(this.$route) && this.initialView) {
    //       this.restoreInitialView();
    //     }
    //   }
    // }
    //   $route: {
    //   immediate: true,
    //   handler(to, from) {
    //     if (from) {
    //       const changed = [];
    //       const keys = new Set([...Object.keys(from.query || {}), ...Object.keys(to.query || {})]);
    //       for (const k of keys) if ((from.query?.[k] || '') !== (to.query?.[k] || '')) changed.push(k);
    //       if (changed.length === 1 && changed[0] === 'location') return; // ← ignoră
    //     }
    //     this.fetchSinglePoiAndOpenFromRoute();
    //   }
    // }
    $route: {
      immediate: true,
      handler(to, from) {
        if (from) {
          const changed = [];
          const keys = new Set([...Object.keys(from.query || {}), ...Object.keys(to.query || {})]);
          for (const k of keys) if ((from.query?.[k] || "") !== (to.query?.[k] || "")) changed.push(k);
          if (changed.length === 1 && changed[0] === "location") return; // ignoră update-urile doar la location
        }
        this.fetchSinglePoiAndOpenFromRoute();
      },
    },
  },

  data() {
    return {
      initialView: null,
      restoringInitial: false,
      coordinates: null,
      hostAddress: M2wApi.host_address,
      project: Vue.config.project,
      showMap3D: false,

      showWeatherMtk: false,
      startWeatherWithLayer: false,
      weatherLayerActive: false,
      weatherLat: null,
      weatherLng: null,
      weatherZoom: 0,
      poisFor3D: null,
      loadedPois: {
        type: "FeatureCollection",
        features: [],
      },
      routingLat: null,
      routingLng: null,
      routingZoom: null,
      routingStart: null,
      routingEnd: null,
      routingMode: "foot",
      triggerCounter: 0,
      currentSelecting: "start",
      hideSettingButtons: false,
      isRoutingActive: false,
      isRouting3DActive: false,
      // inHandover: false,
      lastWeatherView: null,
      allowAutoFly: false,
      close3DOnNextService: false,

      selectedBaseType: "Terrain",
      activeOverlays: [],
      isLayerPickerOpen: false,
      isLayerPickerVisible: true,
      layerWeatherOpen: false,
      layerOverlaysOpen: true,
      urlDebounceT: null,
      serviceByCategory: Object.create(null),
      armedServiceCatId: null,
      lastServiceMeta: null,
      lastServiceOlUid: null,
      isLandscapeOnMobile: false,

      suppressNextPoiDetailsFocus: false,
suppressNextPoiDetailsFocusId: null,
    };
  },
  computed: {
    googleCoords() {
      return this.coordinates ? googleMaps.toGoogleCoordinateString(this.coordinates) : null;
    },
  },

  async mounted() {
    const cameFromRoot = this.$route.path === "/";
    await basemap.initMap(this.$route.query.lid);
    this.setupBasemapLayer();
    if (this.$route.path === "/" && Vue.config.project.default_view !== "/") {
      await this.$router.push(Vue.config.project.default_view);
    }
    this.fetchLocationUrl();
    // window.addEventListener("popstate", this.fetchLocationUrl);
    basemap.map.on("moveend", () => {
      if (this.showWeatherMtk) return;
      const view = basemap.map.getView();
      const c = googleMaps.transformToLatLngLiteral(view.getCenter());
      const z = view.getZoom();

      this.saveCurrentPosition({lat: c.lat, lng: c.lng, zoom: z});
      this.setUrlLocation(c.lat, c.lng, z, {keepMtk: false});
    });
    this.$root.$on("poisLoaded", this.handleLoadedPois);
    // this.$root.$on("poisLoadedPoisPinCategory", this.handleLoadedPois);
    this.$root.$on("focusPois", (fc) => {
      if (this.$route.query.mtk === "1" || this.showWeatherMtk) {
        this.showWeatherMtk = true;
        this.$nextTick(() => {
          this.$refs.weatherMtk?.focusFeatureCollection(fc);
        });
      } else {
        const extent = this._computeExtentForGeoJSON(fc);
        if (extent) {
          const view = basemap.map.getView();
          view.fit(extent, {padding: [40, 40, 80, 40], duration: 800, maxZoom: 17});
        }
      }
    });
    this._onFocusMapAfterAdding = (payload) => {
  const fc = this._toFeatureCollection(payload);
  const feature = fc?.features?.[0];

  const incomingPoiId =
    feature?.properties?.id ??
    feature?.id ??
    payload?.id ??
    null;

  const shouldSuppress =
    this.suppressNextPoiDetailsFocus &&
    String(incomingPoiId ?? "") ===
      String(this.suppressNextPoiDetailsFocusId ?? "");

  if (shouldSuppress) {
    console.log(
      "[MapComponent] focusMapAfterAdding ignorat pentru POI deja focalizat din click 3D",
      {
        id: incomingPoiId,
        geometryType: feature?.geometry?.type,
      }
    );

    this.suppressNextPoiDetailsFocus = false;
    this.suppressNextPoiDetailsFocusId = null;
    return;
  }

  /*
   * Dacă flag-ul era pentru alt POI, îl anulăm.
   * Nu blocăm focusul obiectului primit acum.
   */
  if (this.suppressNextPoiDetailsFocus) {
    console.warn(
      "[MapComponent] flag de suppress necorespunzător; focusul continuă",
      {
        expectedId: this.suppressNextPoiDetailsFocusId,
        incomingPoiId,
      }
    );

    this.suppressNextPoiDetailsFocus = false;
    this.suppressNextPoiDetailsFocusId = null;
  }

  this.$nextTick(() => {
    if (!fc?.features?.length) {
      console.warn(
        "[MapComponent] focusMapAfterAdding: payload invalid",
        payload
      );
      return;
    }

    this.$refs.weatherMtk?.focusFeatureCollection?.(fc);
  });
};

this.$root.$on(
  "focusMapAfterAdding",
  this._onFocusMapAfterAdding
);
    // this.$root.$on("focusMapAfterAdding", (payload) => {
    //   this.$nextTick(() => {
    //     const fc = this._toFeatureCollection(payload);
    //     this.$refs.weatherMtk?.focusFeatureCollection?.(fc);
    //   });
    // });
    this.$root.$on("armClose3D", () => {
      console.log("[MapComponent] armClose3D -> true");
      this.close3DOnNextService = true;
    });
    this.$root.$on("armServiceForCategory", ({catId}) => {
      console.log("[MapComponent] armed for incoming service, catId=", catId);
      this.armedServiceCatId = catId;
    });
    this.$root.$on("deactivateServiceForCategory", ({cat}) => {
      console.log("[MapComponent] deactivateServiceForCategory", cat?.id, cat?.name);
      this.removeServiceForCategory(cat);
    });

    this._closeMTKMapHandler = () => {
      if (this.showWeatherMtk) {
        this.onForceClose3D();
      } else {
        this.setMtkFlag(false);
      }
      this.clearRouting();
    };

    this.$root.$on("closeMTKMap", this._closeMTKMapHandler);

    const view = basemap.map.getView();
    const center = view.getCenter();
    const centerLatLng = googleMaps.transformToLatLngLiteral(center);
    const zoom = view.getZoom();

    this.saveCurrentPosition({
      lat: centerLatLng.lat,
      lng: centerLatLng.lng,
      zoom: zoom,
    });
    this.$root.$on("routingStatus", this.handleRoutingStatus);
    this.$root.$on("restartMapFromHeader", this.restartMap);
    window.addEventListener("m2w:serviceLoaded", this.handleServiceLoaded);
    const mtkParam = this.$route.query.mtk;
    if (mtkParam === "1") {
      this.openWeatherMTK();
    } else if (typeof mtkParam === "undefined" && cameFromRoot) {
      this.openWeatherMTK();
      this.$router
        .replace({
          query: {
            ...this.$route.query,
            mtk: "1",
          },
        })
        .catch(() => {});
    }
    this.checkOrientation();
    window.addEventListener("resize", this.checkOrientation);
  },

  beforeDestroy() {
    window.removeEventListener("popstate", this.fetchLocationUrl);
    this.$root.$off("poisLoaded", this.handleLoadedPois);
    this.$root.$off("focusMapAfterAdding");
    window.removeEventListener("m2w:serviceLoaded", this.handleServiceLoaded);
    this.$root.$off("armServiceForCategory");
    this.$root.$off("deactivateServiceForCategory");
    this.$root.$off("armClose3D");
    this.$root.$off("forceOpenMTKFromFolder");
    this.$root.$off("restartMapFromHeader", this.restartMap);
    window.removeEventListener("resize", this.checkOrientation);
    this.$root.$off("closeMTKMap", this._closeMTKMapHandler);
  },
  methods: {
    async openPoiFromEvent(poi) {
      if (!poi || !poi.id) return;

      await this.$router.push({
        // name: "poiDetails",
        name: "eventDetails",
        params: {
          id: String(poi.id),
        },
        query: {
          ...this.$route.query,
          parent: poi.parent?.id || poi.parent_id || poi.parent,
        },
      });
    },

    checkOrientation() {
      const isEmbedded = window.self !== window.top;

      if (isEmbedded) {
        this.isLandscapeOnMobile = false;
        return;
      }

      const isMobile = window.innerWidth < 900;
      const isLandscape = window.innerWidth > window.innerHeight;

      this.isLandscapeOnMobile = isMobile && isLandscape;
    },
    // getPrintUrl({ isMtk }) {
    //   const url = new URL(window.location.origin + this.$route.path);
    //   const query = { ...this.$route.query };

    //   let view = null;

    //   if (isMtk) {
    //     view =
    //       this.lastWeatherView ||
    //       this.$refs.weatherMtk?.getCurrentView?.() ||
    //       this.readLatLngZoomFromUrl?.();
    //   } else {
    //     view = this.readLatLngZoomFromUrl?.();
    //     if (!view) {
    //       const olView = basemap.map.getView();
    //       const centerLatLng = googleMaps.transformToLatLngLiteral(olView.getCenter());
    //       view = {
    //         lat: centerLatLng.lat,
    //         lng: centerLatLng.lng,
    //         zoom: olView.getZoom(),
    //       };
    //     }
    //   }

    //   if (view) {
    //     const [x, y] = googleMaps.transformFromLatLng({
    //       lat: view.lat,
    //       lng: view.lng,
    //     });
    //     const serialized = `${Math.round(x)},${Math.round(y)},${Math.round(view.zoom)}`;
    //     query.location = serialized;
    //   }
    //   if (isMtk) {
    //     query.mtk = "1";
    //   } else {
    //     delete query.mtk;
    //   }
    //   Object.entries(query).forEach(([key, value]) => {
    //     if (value != null && value !== "") {
    //       url.searchParams.set(key, value);
    //     }
    //   });

    //   return url.toString();
    // },

    getPrintUrl({isMtk}) {
      const url = new URL(window.location.origin + this.$route.path);
      const query = {...this.$route.query};

      let view = null;

      if (isMtk) {
        view = this.lastWeatherView || this.$refs.weatherMtk?.getCurrentView?.() || this.readLatLngZoomFromUrl?.();
      } else {
        const olView = basemap.map.getView();
        const centerLatLng = googleMaps.transformToLatLngLiteral(olView.getCenter());
        view = {
          lat: centerLatLng.lat,
          lng: centerLatLng.lng,
          zoom: olView.getZoom(),
        };
      }

      if (view) {
        const [x, y] = googleMaps.transformFromLatLng({
          lat: view.lat,
          lng: view.lng,
        });
        const serialized = `${Math.round(x)},${Math.round(y)},${Math.round(view.zoom)}`;
        query.location = serialized;
      }

      if (isMtk) {
        query.mtk = "1";
      } else {
        delete query.mtk;
      }

      Object.entries(query).forEach(([key, value]) => {
        if (value != null && value !== "") {
          url.searchParams.set(key, value);
        }
      });

      return url.toString();
    },

    handleServiceLoaded(e) {
      const info = e?.detail || {};
      console.log(
        "[m2w:serviceLoaded]",
        info,
        "close3DOnNextService =",
        this.close3DOnNextService,
        "armedCatId =",
        this.armedServiceCatId
      );
      if (this.close3DOnNextService) {
        this.close3DOnNextService = false;

        let lat, lng, zoom;
        try {
          if (this.showWeatherMtk && this.$refs.weatherMtk?.getCurrentView) {
            const v = this.$refs.weatherMtk.getCurrentView();
            if (v) ({lat, lng, zoom} = v);
          }
          if (lat == null || lng == null || zoom == null) {
            const view = basemap.map.getView();
            const c = googleMaps.transformToLatLngLiteral(view.getCenter());
            lat = c.lat;
            lng = c.lng;
            zoom = view.getZoom();
          }
        } catch (err) {
          console.warn("[handleServiceLoaded] nu am putut citi view-ul curent:", err);
        }

        if (this.showWeatherMtk) {
          this.onForceClose3D();
        } else {
          this.showMap3D = false;
          this.showWeatherMtk = false;
        }

        if (lat != null && lng != null && zoom != null) {
          this.setUrlLocation(lat, lng, zoom, {keepMtk: false});
        } else {
          const q = {...this.$route.query};
          if ("mtk" in q) delete q.mtk;
          this.$router.replace({query: q}).catch(() => {});
        }

        this.$root.$emit("clearAll3D");
      }

      const armedCatId = this.armedServiceCatId ? String(this.armedServiceCatId) : null;
      if (!armedCatId) {
        console.log("[handleServiceLoaded] service loaded, dar nu e armat niciun catId — ignor partea de categorie.");
      } else {
        this.armedServiceCatId = null;

        const catId = armedCatId;
        console.log("[handleServiceLoaded] leg serviciul de categorie catId =", catId);
        this.serviceByCategory[catId] = {...info};

        if (info.cfgName === "cached") {
          console.log('[handleServiceLoaded] cfgName este "cached" → emit autoPinCategoryById pentru', catId);
          this.$root.$emit("autoPinCategoryById", {catId});
        }

        const MAX_TRIES = 10;
        let attempt = 0;

        const tryBindLayerToCategory = (where) => {
          attempt++;
          const layers = basemap.map.getLayers();
          const arr = layers.getArray();

          console.log(`[handleServiceLoaded] tryBindLayerToCategory(${where}) attempt=${attempt} catId=${catId}`);

          arr.forEach((l) => {
            const src = l.getSource?.();
            let srcUrl = null;
            if (src?.getUrl) srcUrl = src.getUrl();
            if (!srcUrl && src?.getUrls) {
              const urls = src.getUrls() || [];
              srcUrl = urls[0] || null;
            }

            console.log("   layer:", {
              ol_uid: l.ol_uid,
              isServiceLayer: l.get?.("isServiceLayer"),
              serviceLayer: l.get?.("serviceLayer"),
              cfgId: l.get?.("cfgId"),
              cfgName: l.get?.("cfgName"),
              categoryId: l.get?.("categoryId"),
              url: srcUrl,
            });
          });

          const pickLast = (predicate) => {
            for (let i = arr.length - 1; i >= 0; i--) {
              const l = arr[i];
              if (predicate(l)) return l;
            }
            return null;
          };

          let match = null;

          match = pickLast((l) => String(l.get?.("categoryId")) === catId) || null;

          if (!match) {
            match =
              pickLast(
                (l) =>
                  l?.get?.("isServiceLayer") &&
                  (!l.get("categoryId") || String(l.get("categoryId")) === catId) &&
                  ((info.layer && l.get("serviceLayer") === info.layer) ||
                    (info.cfgId && l.get("cfgId") === info.cfgId) ||
                    (info.cfgName && l.get("cfgName") === info.cfgName))
              ) || null;
          }
          if (!match && info.url) {
            match =
              pickLast((l) => {
                const src = l.getSource?.();
                if (!src) return false;

                const urls = [];
                if (typeof src.getUrl === "function") {
                  const u = src.getUrl();
                  if (u) urls.push(u);
                }
                if (typeof src.getUrls === "function") {
                  urls.push(...(src.getUrls() || []));
                }

                return urls.some((u) => u && u.indexOf(info.url) !== -1);
              }) || null;
          }

          if (!match) {
            if (attempt < MAX_TRIES) {
              setTimeout(() => {
                try {
                  tryBindLayerToCategory("retry");
                } catch (err) {
                  console.warn("[handleServiceLoaded] layer match error (retry)", err);
                }
              }, 200);
            }
            return;
          }

          if (match.set) {
            match.set("isServiceLayer", true);
            if (info.layer) match.set("serviceLayer", info.layer);
            if (info.cfgId) match.set("cfgId", info.cfgId);
            if (info.cfgName) match.set("cfgName", info.cfgName);
            match.set("categoryId", catId);
          }

          this.serviceByCategory[catId].__olUid = match.ol_uid;
          console.log(
            "[handleServiceLoaded] legat serviciu de catId=",
            catId,
            "-> layer.ol_uid=",
            match.ol_uid,
            "where=",
            where,
            "attempt=",
            attempt
          );
        };

        try {
          tryBindLayerToCategory("immediate");
        } catch (err) {
          console.warn("[handleServiceLoaded] matching layer failed (immediate):", err);
        }
      }
      this.lastServiceMeta = {...info};
      this.lastServiceOlUid = null;

      try {
        const layers = basemap.map.getLayers();
        const arr = layers.getArray();

        const m = info;
        const last = (() => {
          for (let i = arr.length - 1; i >= 0; i--) {
            const l = arr[i];
            if (
              l?.get?.("isServiceLayer") &&
              ((m.cfgId && l.get("cfgId") === m.cfgId) ||
                (m.cfgName && l.get("cfgName") === m.cfgName) ||
                (m.layer && l.get("serviceLayer") === m.layer))
            ) {
              return l;
            }
          }
          return null;
        })();

        if (last) {
          this.lastServiceOlUid = last.ol_uid;
          console.log("[handleServiceLoaded] lastService legat de layer.ol_uid =", last.ol_uid);
        } else {
          console.log(
            "[handleServiceLoaded] lastService: nu am găsit layerul imediat; îl căutăm la removeLastService."
          );
        }
      } catch (err) {
        console.warn("[handleServiceLoaded] matching layer for lastService failed:", err);
      }
    },

    removeServiceForCategory(cat) {
      const rawId = cat?.id;
      if (rawId == null) return;

      const catId = String(rawId);
      const meta = this.serviceByCategory[catId];

      console.log("[removeServiceForCategory] catId=", catId, "meta=", meta);

      const layers = basemap.map.getLayers();
      const arr = layers.getArray();

      arr.forEach((l) => {
        console.log("   [removeServiceForCategory] existent:", {
          ol_uid: l.ol_uid,
          categoryId: l.get?.("categoryId"),
          isServiceLayer: l.get?.("isServiceLayer"),
          cfgName: l.get?.("cfgName"),
          serviceLayer: l.get?.("serviceLayer"),
        });
      });

      const toRemove = [];
      arr.forEach((l) => {
        if (String(l.get?.("categoryId")) === catId) {
          toRemove.push(l);
        }
      });
      if (meta?.__olUid) {
        const byUid = arr.find((l) => l.ol_uid === meta.__olUid);
        if (byUid && !toRemove.includes(byUid)) {
          toRemove.push(byUid);
        }
      }

      if (meta) {
        arr.forEach((l) => {
          if (
            l?.get?.("isServiceLayer") &&
            ((meta.cfgId && l.get("cfgId") === meta.cfgId) ||
              (meta.cfgName && l.get("cfgName") === meta.cfgName) ||
              (meta.layer && l.get("serviceLayer") === meta.layer))
          ) {
            if (!toRemove.includes(l)) {
              toRemove.push(l);
            }
          }
        });
      }

      if (!toRemove.length) {
        console.warn("[removeServiceForCategory] nu găsesc niciun layer pt catId=", catId, "meta=", meta);
        return;
      }

      toRemove.forEach((l) => {
        console.log("[removeServiceForCategory] REMOVE layer", {
          catId,
          ol_uid: l.ol_uid,
          categoryId: l.get?.("categoryId"),
          cfgId: l.get?.("cfgId"),
          cfgName: l.get?.("cfgName"),
          serviceLayer: l.get?.("serviceLayer"),
        });
        layers.remove(l);
      });

      delete this.serviceByCategory[catId];
    },

    removeLastService() {
      if (!this.lastServiceMeta) {
        console.log("[removeLastService] nu am meta stocată — nimic de scos.");
        return;
      }

      const layers = basemap.map.getLayers();
      const arr = layers.getArray();

      let target = this.lastServiceOlUid ? arr.find((l) => l.ol_uid === this.lastServiceOlUid) : null;

      if (!target) {
        const m = this.lastServiceMeta;
        target = arr.find(
          (l) =>
            l?.get?.("isServiceLayer") &&
            ((m.cfgId && l.get("cfgId") === m.cfgId) ||
              (m.cfgName && l.get("cfgName") === m.cfgName) ||
              (m.layer && l.get("serviceLayer") === m.layer))
        );
      }

      if (!target) {
        console.warn("[removeLastService] nu găsesc layerul de scos. Meta:", this.lastServiceMeta);
        return;
      }

      console.log("[removeLastService] REMOVE layer", {
        ol_uid: target.ol_uid,
        cfgId: target.get("cfgId"),
        cfgName: target.get("cfgName"),
        serviceLayer: target.get("serviceLayer"),
        type: target.get("serviceType"),
        categoryId: target.get("categoryId"),
      });

      layers.remove(target);

      this.lastServiceMeta = null;
      this.lastServiceOlUid = null;
    },

    onPoiFrom3D(poi) {
      console.debug("[onPoiFrom3D] route.mtk =", this.$route.query.mtk, "poi =", poi);

      if (this.$route.query.mtk !== "1") {
        console.debug("[onPoiFrom3D] Ignorat — nu e mtk=1 în URL.");
        return;
      }

      try {
        if (!poi) {
          console.warn("[onPoiFrom3D] payload POI lipsă");
          return;
        }

        const poiId = poi.id ?? poi.properties?.id;
        const geom = poi.geom ?? poi.geometry;
        if (!poiId || !geom) {
          console.warn("[onPoiFrom3D] lipsesc id sau geometry în payload", {poiId, geom});
          return;
        }
        /*
 * WeatherMTK.focusFeatureOnce() a focalizat deja geometria
 * înainte să emită evenimentul poi-click.
 */
this.suppressNextPoiDetailsFocus = true;
this.suppressNextPoiDetailsFocusId = String(poiId);
        const feature = {
          type: "Feature",
          geometry: geom,
          properties: {
            ...(poi.properties || {}),
            id: poiId,
            name: poi.name ?? poi.properties?.name,
            parent_id: poi.parent?.id,

            line_color: poi.properties?.line_color ?? poi.style?.line_color ?? poi.line_color,

            width: poi.properties?.width ?? poi.style?.width ?? poi.width,
          },
          // properties: {
          //   ...(poi.properties || {}),
          //   id: poiId,
          //   name: poi.name ?? poi.properties?.name,
          //   parent_id: poi.parent?.id,
          // },
        };
        //pt layer items
        //         const feature = {
        //   type: "Feature",
        //   geometry: geom,

        //   properties: {
        //     ...(poi.properties || {}),

        //     id: poiId,
        //     name: poi.name ?? poi.properties?.name,
        //     parent_id:
        //       poi.parent?.id ??
        //       poi.properties?.parent_id,

        //     icon:
        //       poi.properties?.icon ??
        //       poi.icon,

        //     line_color:
        //       poi.properties?.line_color ??
        //       poi.properties?.dbLineColor ??
        //       poi.style?.line_color ??
        //       poi.line_color,

        //     width:
        //       poi.properties?.width ??
        //       poi.properties?.line_width ??
        //       poi.properties?.dbLineWidth ??
        //       poi.style?.width ??
        //       poi.width,

        //     fill_color:
        //       poi.properties?.fill_color ??
        //       poi.properties?.dbFillColor ??
        //       poi.style?.fill_color,

        //     fill_opacity:
        //       poi.properties?.fill_opacity ??
        //       poi.properties?.dbFillOpacity,
        //   },
        // };

        this.poisFor3D = {type: "FeatureCollection", features: [feature]};
        const query = {...this.$route.query, parent: poi.parent?.id, mtk: "1"};

        // this.$router.push({name: "poiDetails", params: {id: String(poiId)}, query}).catch((err) => {
        //   if (err && err.name !== "NavigationDuplicated") {
        //     console.error("[onPoiFrom3D] router.push error:", err);
        //   }
        // });
this.$router
  .push({
    name: "poiDetails",
    params: {
      id: String(poiId),
    },
    query,
  })
  .catch((err) => {
    /*
     * Dacă navigarea nu s-a realizat, PoiDetails nu va emite
     * focusMapAfterAdding. Curățăm flag-ul.
     */
    this.suppressNextPoiDetailsFocus = false;
    this.suppressNextPoiDetailsFocusId = null;

    if (err?.name !== "NavigationDuplicated") {
      console.error(
        "[onPoiFrom3D] router.push error:",
        err
      );
    }
  });
        console.log("[onPoiFrom3D] deschide detaliul POI pentru harta 3D:", poiId);
      } catch (e) {
        console.error("[onPoiFrom3D] exception:", e);
      }
    },

    _toFeatureCollection(payload) {
      if (!payload) return null;
      if (payload.type === "FeatureCollection") return payload;

      if (payload.type === "Feature" && payload.geometry?.type && payload.geometry.coordinates) {
        return {type: "FeatureCollection", features: [payload]};
      }

      const g = payload.geometry || payload.geom || payload.properties?.geometry;
      if (g?.type && g?.coordinates) {
        return {
          type: "FeatureCollection",
          features: [{type: "Feature", geometry: g, properties: payload.properties || {...payload}}],
        };
      }

      const lat = payload.lat ?? payload.latitude;
      const lng = payload.lng ?? payload.lon ?? payload.longitude;
      if (lat != null && lng != null) {
        return {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {type: "Point", coordinates: [Number(lng), Number(lat)]},
              // properties: {...payload},
              properties: {
                ...(payload.properties || {...payload}),
                line_color: payload.properties?.line_color ?? payload.style?.line_color ?? payload.line_color,
                width: payload.properties?.width ?? payload.style?.width ?? payload.width,
              },
            },
          ],
        };
      }
      return null;
    },
    _computeExtentForGeoJSON(fc) {
      if (!fc?.features?.length) return null;
      const pts = [];
      const push = (c) => {
        if (Array.isArray(c) && typeof c[0] === "number") pts.push(c);
      };
      const walk = (g) => {
        if (!g) return;
        const t = g.type,
          c = g.coordinates;
        if (t === "Point") push(c);
        else if (t === "LineString") c.forEach(push);
        else if (t === "MultiLineString") c.flat().forEach(push);
        else if (t === "Polygon") c[0].forEach(push);
        else if (t === "MultiPolygon") c.flat(2).forEach(push);
      };
      fc.features.forEach((f) => walk(f.geometry));
      if (!pts.length) return null;

      const to3857 = (lng, lat) => googleMaps.transformFromLatLng({lat, lng});
      let minX = +Infinity,
        minY = +Infinity,
        maxX = -Infinity,
        maxY = -Infinity;
      pts.forEach(([lng, lat]) => {
        const [x, y] = to3857(lng, lat);
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      });
      return [minX, minY, maxX, maxY];
    },
    setMtkFlag(flag) {
      const q = {...this.$route.query};
      if (flag) {
        if (q.mtk !== "1") this.$router.replace({query: {...q, mtk: "1"}});
      } else {
        if ("mtk" in q) {
          delete q.mtk;
          this.$router.replace({query: q});
        }
      }
    },
    setUrlLocation(lat, lng, zoom, {keepMtk = true} = {}) {
      const [x, y] = googleMaps.transformFromLatLng({lat, lng});
      const serialized = `${Math.round(x)},${Math.round(y)},${Math.round(zoom)}`;
      const q = {...this.$route.query, location: serialized};
      if (keepMtk && this.showWeatherMtk) q.mtk = "1";
      if (this.$route.query.location !== serialized || this.$route.query.mtk !== q.mtk) {
        this.$router.replace({query: q});
        localStorage.setItem("lastLocation", serialized);
      }
    },

    setUrlLocationDebounced(lat, lng, zoom) {
      clearTimeout(this.urlDebounceT);
      this.urlDebounceT = setTimeout(() => this.setUrlLocation(lat, lng, zoom, {keepMtk: true}), 150);
    },

    readLatLngZoomFromUrl() {
      const loc = this.$route?.query?.location;
      if (!loc) return null;

      const m = String(loc).match(/^([-0-9.]+),([-0-9.]+),([0-9.]+)$/);
      if (!m) return null;

      const [, xStr, yStr, zStr] = m;
      const x = Number(xStr),
        y = Number(yStr),
        z = Number(zStr);
      if (!Number.isFinite(x) || !Number.isFinite(y) || !Number.isFinite(z)) return null;

      // 3857 -> WGS84
      const {lat, lng} = googleMaps.transformToLatLngLiteral([x, y]);
      return {lat, lng, zoom: z};
    },
    onToggleOverlays(name) {
      const i = this.activeOverlays.indexOf(name);
      if (i >= 0) this.activeOverlays.splice(i, 1);
      else this.activeOverlays.push(name);

      if (name === "Weather" || name === "Temperature" || name === "Precipitation" || name === "Wind") {
        this.handleToggleWeather();
      } else {
        basemap?.toggleOverlays?.(name);
      }
    },
    onCloseLayerPicker() {
      this.isLayerPickerVisible = false;
    },
    onSelectBaseType(typeName) {
      this.selectedBaseType = typeName;
      basemap?.setBase?.(typeName);
    },
    onToggleOverlay(overlayName) {
      const i = this.activeOverlays.indexOf(overlayName);
      if (i >= 0) this.activeOverlays.splice(i, 1);
      else this.activeOverlays.push(overlayName);

      if (overlayName === "Weather") {
        this.handleToggleWeather();
      } else {
        basemap?.toggleOverlay?.(overlayName);
      }
    },

    isMainPanel(route = this.$route) {
      if (route.path === "/") return true;
      if (route.name === "home" || route.name === "categoriesRoot") return true;
      return false;
    },
    restoreInitialView() {
      try {
        const raw = sessionStorage.getItem("initialView");
        const iv = raw ? JSON.parse(raw) : this.initialView;
        if (!iv) return;

        const {lat, lng, zoom} = iv;
        const view = basemap.map.getView();

        this.restoringInitial = true;
        view.setCenter(googleMaps.transformFromLatLng({lat, lng}));
        if (typeof zoom === "number") view.setZoom(zoom);

        this.$nextTick(() => {
          setTimeout(() => (this.restoringInitial = false), 250);
        });
      } catch (e) {
        sessionStorage.removeItem("initialView");
      }
    },

    resetMapToProjectDefaults() {
      const projectCenter = this.project?.center;
      const projectZoom = this.project?.default_zoom ?? 13;

      if (!Array.isArray(projectCenter) || projectCenter.length < 2) {
        console.warn("[resetMapToProjectDefaults] project.center lipsește sau este invalid:", projectCenter);
        return false;
      }

      const [x, y] = projectCenter;
      const zoom = Number(projectZoom);

      if (!Number.isFinite(x) || !Number.isFinite(y) || !Number.isFinite(zoom)) {
        console.warn("[resetMapToProjectDefaults] center/zoom invalid:", {projectCenter, projectZoom});
        return false;
      }

      const view = basemap.map.getView();
      view.setCenter([x, y]);
      view.setZoom(zoom);

      const {lat, lng} = googleMaps.transformToLatLngLiteral([x, y]);
      this.saveCurrentPosition({lat, lng, zoom}, {syncOL: false});

      return true;
    },
    async restartMap() {
      console.log("[MapComponent] restartMap");

      const keepMtk = this.$route.query.mtk === "1";

      this.$refs.menu?.close?.();
      this.$root.$data.printMode = false;

      // reset routing
      this.clearRouting();
      this.triggerCounter = 0;
      this.currentSelecting = "start";

      // reset stare weather / 3D / POI
      this.weatherLayerActive = false;
      this.startWeatherWithLayer = false;
      this.close3DOnNextService = false;
      this.lastWeatherView = null;

      this.poisFor3D = {
        type: "FeatureCollection",
        features: [],
      };

      // curăță layere dinamice
      Object.keys(this.serviceByCategory).forEach((catId) => {
        const meta = this.serviceByCategory[catId];
        const layers = basemap.map.getLayers();
        const arr = layers.getArray();

        arr.slice().forEach((l) => {
          const sameCategory = String(l.get?.("categoryId")) === String(catId);
          const sameUid = meta?.__olUid && l.ol_uid === meta.__olUid;
          if (sameCategory || sameUid) {
            layers.remove(l);
          }
        });
      });

      this.serviceByCategory = Object.create(null);
      this.lastServiceMeta = null;
      this.lastServiceOlUid = null;

      // coordonate default proiect
      const projectCenter = this.project?.center;
      const projectZoom = Number(this.project?.default_zoom ?? 13);

      if (!Array.isArray(projectCenter) || projectCenter.length < 2) {
        console.warn("[restartMap] project.center invalid", projectCenter);
        return;
      }

      const [x, y] = projectCenter;
      const {lat, lng} = googleMaps.transformToLatLngLiteral([x, y]);

      // actualizează starea internă
      this.weatherLat = lat;
      this.weatherLng = lng;
      this.weatherZoom = projectZoom;

      this.routingLat = lat;
      this.routingLng = lng;
      this.routingZoom = projectZoom;

      this.map3dLat = lat;
      this.map3dLng = lng;
      this.map3dZoom = projectZoom;

      // OL reset
      const view = basemap.map.getView();
      view.setCenter([x, y]);
      view.setZoom(projectZoom);

      // decide ce hartă rămâne activă
      this.showMap3D = false;
      this.showWeatherMtk = keepMtk;

      const query = {
        location: `${Math.round(x)},${Math.round(y)},${Math.round(projectZoom)}`,
      };

      if (keepMtk) {
        query.mtk = "1";
      }

      await this.$router
        .replace({
          name: "default",
          query,
        })
        .catch(() => {});

      await this.$nextTick();

      // IMPORTANT: reset explicit pentru MTK
      if (keepMtk && this.$refs.weatherMtk) {
        if (typeof this.$refs.weatherMtk.resetToHome === "function") {
          this.$refs.weatherMtk.resetToHome({
            lat,
            lng,
            zoom: projectZoom,
          });
        } else if (typeof this.$refs.weatherMtk.flyTo === "function") {
          this.$refs.weatherMtk.flyTo({
            lat,
            lng,
            zoom: projectZoom,
          });
        }
      }

      this.$root.$emit("clearAll3D");
      this.$root.$emit("reset3DToHome", {
        lat,
        lng,
        zoom: projectZoom,
      });
      this.$root.$emit("openCategoriesMenu", {withOverlay: false});
    },
    async openMtkForPoiId(poiId) {
      if (!poiId) return false;

      const parent = this.$route.query.parent;
      const lang = this.$i18n?.locale;

      let json;
      try {
        json = await M2wApi.get_single_poi(String(poiId), lang, parent);
      } catch (e) {
        console.error("[openMtkForPoiId] get_single_poi failed", e);
      }

      const webMercatorToWgs84 = ([x, y]) => {
        const R = 6378137;
        const lon = ((x / R) * 180) / Math.PI;
        const lat = ((2 * Math.atan(Math.exp(y / R)) - Math.PI / 2) * 180) / Math.PI;
        return [lon, lat];
      };

      const fromJsonToFeature = (j) => {
        if (!j) return null;
        if (j.type === "Feature" && j.geometry?.type && j.geometry?.coordinates) return j;
        if (j.properties?.geometry?.type && j.properties.geometry.coordinates)
          return {type: "Feature", geometry: j.properties.geometry, properties: {...j.properties}};
        if (j.geometry?.type && j.geometry.coordinates)
          return {type: "Feature", geometry: j.geometry, properties: j.properties || {}};
        if (j.geom?.type && Array.isArray(j.geom.coordinates)) {
          const crsName = j.geom?.crs?.properties?.name || j.geom?.crs?.name || "";
          const is3857 = /3857|900913/i.test(crsName);
          const conv = (c) => (is3857 ? webMercatorToWgs84(c) : c);
          const g = j.geom;
          let geometry = null;
          if (g.type === "Point") geometry = {type: "Point", coordinates: conv(g.coordinates)};
          else if (g.type === "LineString") geometry = {type: "LineString", coordinates: g.coordinates.map(conv)};
          else if (g.type === "MultiLineString")
            geometry = {type: "MultiLineString", coordinates: g.coordinates.map((line) => line.map(conv))};
          else if (g.type === "Polygon")
            geometry = {type: "Polygon", coordinates: g.coordinates.map((r) => r.map(conv))};
          else if (g.type === "MultiPolygon")
            geometry = {type: "MultiPolygon", coordinates: g.coordinates.map((p) => p.map((r) => r.map(conv)))};
          if (geometry) return {type: "Feature", geometry, properties: {...j}};
        }
        const lat = j.lat ?? j.latitude,
          lng = j.lng ?? j.lon ?? j.longitude;
        if (lat != null && lng != null)
          return {
            type: "Feature",
            geometry: {type: "Point", coordinates: [Number(lng), Number(lat)]},
            properties: {...j},
          };
        return null;
      };

      let feature = fromJsonToFeature(json);
      console.log(feature);

      if (!feature?.geometry) {
        try {
          const all = await M2wApi.get_project_pois(lang);
          if (all?.type === "FeatureCollection") {
            const found = all.features.find((f) => String(f?.properties?.id ?? f?.id) === String(poiId));
            if (found?.geometry) feature = found;
          }
        } catch (e2) {
          console.warn("[openMtkForPoiId] fallback get_project_pois failed", e2);
        }
      }
      if (!feature?.geometry) return false;

      const icon = feature?.properties?.icon || feature?.properties?.marker || feature?.properties?.logo;
      if (icon && !/^https?:\/\//i.test(icon)) {
        feature.properties.icon = (M2wApi.host_address || "").replace(/\/+$/, "") + icon;
      }

      this.poisFor3D = {type: "FeatureCollection", features: [feature]};
      this.showWeatherMtk = true;
      this.startWeatherWithLayer = false;
      this.weatherLayerActive = false;

      return true;
    },
    async fetchSinglePoiAndOpenFromRoute() {
      const isPoiView = this.$route.path.startsWith("/poi/") || this.$route.name === "poiDetails";
      if (!isPoiView) return false;

      const poiId = this.$route.params.id || (this.$route.path.split("/")[2] || "").split("?")[0];
      if (!poiId) return false;

      const parent = this.$route.query.parent;
      const lang = this.$i18n?.locale;

      // 3857 -> 4326
      const webMercatorToWgs84 = ([x, y]) => {
        const R = 6378137;
        const lon = ((x / R) * 180) / Math.PI;
        const lat = ((2 * Math.atan(Math.exp(y / R)) - Math.PI / 2) * 180) / Math.PI;
        return [lon, lat];
      };

      const normalizeSinglePoi = (json) => {
        if (!json) return null;

        if (json.type === "Feature" && json.geometry?.type && json.geometry?.coordinates) {
          return json;
        }
        if (json.type === "FeatureCollection" && Array.isArray(json.features) && json.features.length === 1) {
          return json.features[0];
        }
        if (json.properties?.geometry?.type && json.properties.geometry.coordinates) {
          return {type: "Feature", geometry: json.properties.geometry, properties: {...json.properties}};
        }
        if (json.geometry?.type && json.geometry?.coordinates) {
          return {type: "Feature", geometry: json.geometry, properties: json.properties || {}};
        }

        if (json.geom?.type && Array.isArray(json.geom.coordinates)) {
          const crsName = json.geom?.crs?.properties?.name || json.geom?.crs?.name || "";
          const is3857 = /3857|900913/i.test(crsName);
          const toWgs = (c) => (is3857 ? webMercatorToWgs84(c) : c);

          const g = json.geom;
          let geometry = null;

          if (g.type === "Point") {
            geometry = {type: "Point", coordinates: toWgs(g.coordinates)};
          } else if (g.type === "LineString") {
            geometry = {type: "LineString", coordinates: g.coordinates.map(toWgs)};
          } else if (g.type === "MultiLineString") {
            geometry = {type: "MultiLineString", coordinates: g.coordinates.map((line) => line.map(toWgs))};
          } else if (g.type === "Polygon") {
            geometry = {type: "Polygon", coordinates: g.coordinates.map((ring) => ring.map(toWgs))};
          } else if (g.type === "MultiPolygon") {
            geometry = {
              type: "MultiPolygon",
              coordinates: g.coordinates.map((poly) => poly.map((ring) => ring.map(toWgs))),
            };
          }

          if (geometry) {
            const properties = {...json};

            // if (json.style) {
            //   properties.line_color = json.style.line_color ?? properties.line_color;
            //   properties.width = json.style.width ?? properties.width;
            //   properties.fill_color = json.style.fill_color ?? properties.fill_color;
            //   if (typeof json.style.fill_transparency === "number") {
            //     properties.fill_opacity = Math.max(0, Math.min(1, 1 - json.style.fill_transparency / 100));
            //   }
            // }
            if (json.style) {
              properties.line_color = json.style.line_color ?? json.style.color ?? properties.line_color;

              properties.width =
                json.style.width ??
                json.style.line_width ??
                json.style.line_thickness ??
                json.width ??
                json.line_width ??
                json.line_thickness ??
                properties.width;

              properties.line_width = properties.width;
              properties.line_thickness = properties.width;

              properties.fill_color = json.style.fill_color ?? properties.fill_color;

              if (typeof json.style.fill_transparency === "number") {
                properties.fill_opacity = Math.max(0, Math.min(1, 1 - json.style.fill_transparency / 100));
              }
            }

            properties.icon = properties.icon || json.marker || json.logo;

            if (properties.icon && !/^https?:\/\//i.test(properties.icon)) {
              properties.icon = (M2wApi.host_address || "").replace(/\/+$/, "") + properties.icon;
            }

            if (json.name) properties.name = json.name;
            return {type: "Feature", geometry, properties};
          }
        }

        const lat = json.lat ?? json.latitude ?? json.properties?.lat ?? json.properties?.latitude;
        const lng =
          json.lng ??
          json.lon ??
          json.longitude ??
          json.properties?.lng ??
          json.properties?.lon ??
          json.properties?.longitude;
        if (lat != null && lng != null) {
          return {
            type: "Feature",
            geometry: {type: "Point", coordinates: [Number(lng), Number(lat)]},
            properties: {...json.properties, ...json},
          };
        }

        return null;
      };

      try {
        const json = await M2wApi.get_single_poi(poiId, lang, parent);

        const feature = normalizeSinglePoi(json);

        if (feature?.properties?.icon && !/^https?:\/\//i.test(feature.properties.icon)) {
          feature.properties.icon = (M2wApi.host_address || "").replace(/\/+$/, "") + feature.properties.icon;
        }

        if (feature?.geometry) {
          this.poisFor3D = {type: "FeatureCollection", features: [feature]};
          if (this.$route.query.mtk === "1") {
            this.showWeatherMtk = true;
          }

          this.startWeatherWithLayer = false;
          this.weatherLayerActive = false;
          return true;
        }
      } catch (e) {
        console.error("[single-poi] error", e);
      }

      const fromLoaded = this.loadedPois?.features?.find((f) => String(f?.properties?.id ?? f?.id) === String(poiId));
      if (fromLoaded) {
        this.poisFor3D = {type: "FeatureCollection", features: [JSON.parse(JSON.stringify(fromLoaded))]};
        if (this.$route.query.mtk === "1") {
          this.showWeatherMtk = true;
        }

        this.startWeatherWithLayer = false;
        this.weatherLayerActive = false;
        return true;
      }

      try {
        const all = await M2wApi.get_project_pois(lang);
        if (all?.type === "FeatureCollection") {
          const f = all.features.find((f) => String(f?.properties?.id ?? f?.id) === String(poiId));
          if (f) {
            this.poisFor3D = {type: "FeatureCollection", features: [f]};
            // this.showWeatherMtk = true;
            if (this.$route.query.mtk === "1") {
              this.showWeatherMtk = true;
            }

            this.startWeatherWithLayer = false;
            this.weatherLayerActive = false;
            return true;
          }
        }
      } catch (err2) {
        console.warn("[single-poi] fallback get_project_pois a eșuat:", err2);
      }

      // this.showWeatherMtk = true;
      if (this.$route.query.mtk === "1") {
        this.showWeatherMtk = true;
      }

      this.startWeatherWithLayer = false;
      this.weatherLayerActive = false;

      const loc = this.$route.query.location;
      if (loc) {
        const m = String(loc).match(/^([-0-9.]+),([-0-9.]+),([0-9.]+)/);
        if (m) {
          const [x, y, z] = m.slice(1).map(Number);
          const {lat, lng} = googleMaps.transformToLatLngLiteral([x, y]);
          this.weatherLat = lat;
          this.weatherLng = lng;
          this.weatherZoom = z;
        }
      }

      return false;
    },

    openMtkWithPoi(feature) {
      if (!feature || !feature.properties) return;

      const poiId = feature.properties.id;
      this.$router.replace({
        query: {
          ...this.$route.query,
          poi: String(poiId),
        },
      });

      this.poisFor3D = {
        type: "FeatureCollection",
        features: [JSON.parse(JSON.stringify(feature))],
      };

      if (this.$route.query.mtk === "1") {
        this.showWeatherMtk = true;
      }
    },
    handleRoutingStatus({isRoutingActive}) {
      this.isRoutingActive = isRoutingActive;

      if (!isRoutingActive) {
        this.$root.$emit("openCategoriesMenu", {withOverlay: false});
      }
    },

    switchMapLibreTo2D() {
      console.log("Switching to 2D map...");
    },
    async setupBasemapLayer() {
      const cfg = Vue.config.project.sf_basemap;
      if (!cfg) return;
      try {
        let layer;
        switch (cfg.type) {
          case "wmts":
            layer = await basemap.getWmtsLayer(cfg);
            break;
          case "wms":
            layer = await basemap.getWmsLayer(cfg);
            break;
          case "xyz":
            layer = await basemap.getXyzLayer(cfg);
            break;
        }
        if (layer) {
          layer.setZIndex(ZIndex.SFMap);
          Vue.config.project.sf_basemap.layer = layer;
          basemap.map.addLayer(layer);
        }
      } catch (e) {
        console.error("Eroare la adăugarea stratului de bază:", e);
      }
    },

    updateUrlLocationFromLatLng(lat, lng, zoom) {
      const [x, y] = googleMaps.transformFromLatLng({lat, lng});
      const serialized = `${Math.round(x)},${Math.round(y)},${Math.round(zoom)}`;

      if (this.$route.query.location !== serialized) {
        this.$router.replace({
          query: {...this.$route.query, location: serialized},
        });
        localStorage.setItem("lastLocation", serialized);
      }
    },

    fetchLocationUrl() {
      const location = this.$route.query.location;
      if (!location) return;
      const match = location.match(/^([-0-9.]+),([-0-9.]+),([0-9.]+)$/);
      if (!match) return;
      const [_, x, y, zoom] = match.map(Number);
      const view = basemap.map.getView();
      view.setCenter([x, y]);
      view.setZoom(zoom);
      if (Vue.config.project.sf_basemap && !isNaN(this.$route.query.sflo)) {
        const opacity = parseInt(this.$route.query.sflo, 10);
        if (opacity >= 0 && opacity <= 100) {
          Vue.config.project.sf_basemap.layer.setOpacity(opacity / 100);
        }
      }
    },
    setCoordinates(event) {
      this.coordinates = basemap.map.getEventCoordinate(event);
    },
    async copyCoordinates() {
      await Clipboard.copy(this.googleCoords);
    },
    async getNearestPoi() {
      const poi = await M2wApi.get_closest_poi(this.coordinates, this.$i18n.locale);
      const baseQuery = {...this.$route.query, wh: "1"};

      if (poi.obj) {
        await this.$router.push({
          name: "poiDetails",
          params: {id: poi.obj},
          query: baseQuery,
        });
      } else if (poi.address) {
        await this.$router.push({
          name: "pois",
          params: {view: "streets"},
          query: {
            ...baseQuery,
            str_id: poi.address.id,
            hnr: poi.address.house_number.hnr,
          },
        });
      }
      this.$refs.menu.close();
    },
    // async getNearestPoi() {
    //   const poi = await M2wApi.get_closest_poi(this.coordinates, this.$i18n.locale);
    //   if (poi.obj) {
    //     await this.$router.push({name: "poiDetails", params: {id: poi.obj}, query: this.$route.query});
    //   } else if (poi.address) {
    //     await this.$router.push({
    //       name: "pois",
    //       params: {view: "streets"},
    //       query: {...this.$route.query, str_id: poi.address.id, hnr: poi.address.house_number.hnr},
    //     });
    //   }
    //   this.$refs.menu.close();
    // },
    togglePrintMode() {
      this.$root.$emit("closeMTKMap");
      this.$root.$data.printMode = !this.$root.$data.printMode;
      this.$refs.menu.close();
    },
    goToMeasure() {
      this.$router.push({name: "measure"});
      this.$refs.menu.close();
    },
    setStartpoint() {
      this.$router.push({name: "directions", query: {...this.$route.query, from: this.googleCoords}});
      this.$refs.menu.close();
    },
    setEndpoint() {
      this.$router.push({name: "directions", query: {...this.$route.query, to: this.googleCoords}});
      this.$refs.menu.close();
    },

    saveCurrentPosition({lat, lng, zoom}, {syncOL = !this.showWeatherMtk} = {}) {
      this.map3dLat = lat;
      this.map3dLng = lng;
      this.map3dZoom = zoom;
      this.weatherLat = lat;
      this.weatherLng = lng;
      this.weatherZoom = zoom;
      this.routingLat = lat;
      this.routingLng = lng;
      this.routingZoom = zoom;
      this.$root.$data.globalRoutingPosition = {lat, lng, zoom};

      if (syncOL) {
        const center = googleMaps.transformFromLatLng({lat, lng});
        const view = basemap.map.getView();
        view.setCenter(center);
        view.setZoom(zoom);
      }
    },

    openWeatherMTK() {
      const saved = sessionStorage.getItem("mtkLastView");
      if (saved) {
        try {
          const {lat, lng, zoom} = JSON.parse(saved);
          this.weatherLat = lat;
          this.weatherLng = lng;
          this.weatherZoom = zoom;
        } catch (e) {
          /**/
        }
      }

      if (this.weatherLat == null || this.weatherLng == null) {
        const view = basemap.map.getView();
        if (view) {
          const c = googleMaps.transformToLatLngLiteral(view.getCenter());
          this.weatherLat = c.lat;
          this.weatherLng = c.lng;
          this.weatherZoom = view.getZoom();
        }
      }

      if (this.weatherLat == null || this.weatherLng == null) {
        const fromUrl = this.readLatLngZoomFromUrl?.();
        if (fromUrl) {
          this.weatherLat = fromUrl.lat;
          this.weatherLng = fromUrl.lng;
          this.weatherZoom = fromUrl.zoom;
        }
      }

      this.startWeatherWithLayer = true;
      this.close3DOnNextService = false;

      this.showWeatherMtk = true;
      this.setMtkFlag(true);

      this.setUrlLocation(this.weatherLat, this.weatherLng, this.weatherZoom, {keepMtk: true});

      this.handleToggle3D();
      this.clearRouting();
    },

    toggleWeather() {
      if (this.$refs.weatherMtk) {
        if (this.weatherLayerActive) {
          this.setMtkFlag(true);
          this.$refs.weatherMtk.disableWeatherLayer();
          this.weatherLayerActive = false;
        } else {
          this.$refs.weatherMtk.enableWeatherLayer();
          this.setMtkFlag(true);
          this.weatherLayerActive = true;
        }
      }
    },

    openMap3DView() {
      this.startWithWeather = false;
      this.weatherLayerActive = false;
      this.showWeatherMtk = true;
      this.setMtkFlag(true);
    },

    on3DMapMoved({lat, lng, zoom}) {
      console.log(" on3DMapMoved", {lat, lng, zoom});
      this.saveCurrentPosition({lat, lng, zoom});
    },

    onWeatherMapMoved({lat, lng, lon, zoom}) {
      const L = lng != null ? lng : lon;
      const payload = {lat, lng: L, zoom};
      this.lastWeatherView = payload;
      this.saveCurrentPosition(payload, {syncOL: false});
      this.setUrlLocationDebounced(lat, L, zoom);
    },

    onWeatherMapClosedd({lat, lng, zoom} = {}) {
      let viewPayload = null;

      if (lat != null && lng != null && zoom != null) {
        viewPayload = {lat, lng, zoom};
      } else if (this.lastWeatherView) {
        viewPayload = {...this.lastWeatherView};
      } else if (this.$refs.weatherMtk?.getCurrentView) {
        const v = this.$refs.weatherMtk.getCurrentView();
        if (v) viewPayload = v;
      } else {
        const olView = basemap.map.getView();
        const centerWgs = googleMaps.transformToLatLngLiteral(olView.getCenter());
        viewPayload = {lat: centerWgs.lat, lng: centerWgs.lng, zoom: olView.getZoom()};
      }

      const {lat: LAT, lng: LNG, zoom: Z} = viewPayload;

      const center3857 = googleMaps.transformFromLatLng({lat: LAT, lng: LNG});
      const olView = basemap.map.getView();
      olView.setCenter(center3857);
      olView.setZoom(Z);

      this.weatherLat = LAT;
      this.weatherLng = LNG;
      this.weatherZoom = Z;

      this.map3dLat = LAT;
      this.map3dLng = LNG;
      this.map3dZoom = Z;

      this.updateUrlLocationFromLatLng(LAT, LNG, Z);
      this.showWeatherMtk = false;
      return viewPayload;
    },

    onWeatherMapClosed({lat, lng, zoom}) {
      const center = googleMaps.transformFromLatLng({lat, lng});
      const view = basemap.map.getView();
      view.setCenter(center);
      view.setZoom(zoom);

      this.weatherLat = lat;
      this.weatherLng = lng;
      this.weatherZoom = zoom;
      this.map3dLat = lat;
      this.map3dLng = lng;
      this.map3dZoom = zoom;

      this.setUrlLocation(lat, lng, zoom, {keepMtk: false});
      this.setMtkFlag(false);

      this.showWeatherMtk = false;
    },

    handleToggleWeather() {
      const weatherRef = this.$refs.weatherMtk;
      if (weatherRef && typeof weatherRef.toggleWeatherLayer === "function") {
        this.setMtkFlag(true);
        weatherRef.toggleWeatherLayer();
        this.weatherLayerActive = !this.weatherLayerActive;
      } else {
        console.warn("WeatherMTK ref or toggle method is missing.");
      }
    },

    onWeatherLayerClosed() {
      console.log("onWeatherLayerClosed", {
        lat: this.weatherLat,
        lng: this.weatherLng,
        zoom: this.weatherZoom,
      });

      this.showWeatherMtk = false;
      this.setMtkFlag(true);

      this.saveCurrentPosition({
        lat: this.weatherLat,
        lng: this.weatherLng,
        zoom: this.weatherZoom,
      });
    },
    handleLoadedPois(geojsonPois) {
      const isValid = geojsonPois && geojsonPois.type === "FeatureCollection" && Array.isArray(geojsonPois.features);

      if (!isValid || geojsonPois.features.length === 0) {
        console.warn("POIs are empty or invalid GeoJSON!");
        this.poisFor3D = {
          type: "FeatureCollection",
          features: [],
        };
        return;
      }
      const deReactive = JSON.parse(JSON.stringify(geojsonPois));

      console.log("GeoJSON POIs for MapLibre:", deReactive);
      console.log("Features count:", deReactive.features.length);

      this.loadedPois = deReactive;
      console.log("FitBounds POI form :handleLoadedPois");
      // this.allowAutoFly = true;
      const poiIdFromUrl = this.$route.query.poi;
      if (poiIdFromUrl) {
        const one = deReactive.features.find((f) => String(f?.properties?.id) === String(poiIdFromUrl));
        if (one) {
          this.poisFor3D = {type: "FeatureCollection", features: [one]};
          if (this.$route.query.mtk === "1") {
            this.showWeatherMtk = true;
          }
          return;
        }
      }
      this.poisFor3D = deReactive;
    },

    handleToggle3D() {
      if (this.showMap3D) {
        this.on3DMapClosed();
      }
    },
    onStart(coords) {
      this.$root.$data.routingStart = coords;
    },
    onEnd(coords) {
      this.$root.$data.routingEnd = coords;
    },
    onModeChanged(mode) {
      this.routingMode = mode;
    },
    onRoutingTrigger() {
      this.isRoutingActive = true;
      if (this.routingStart && this.routingEnd && this.$refs.map3d) {
        this.$refs.map3d.calculateRouteFromPanel(this.routingStart, this.routingEnd, this.routingMode);
      } else {
        alert("Coordinates are not defined.");
      }
    },
    clearRouting() {
      this.routingStart = null;
      this.routingEnd = null;
      this.$nextTick(() => this.$root.$emit("openCategoriesMenu", {withOverlay: false}));
    },
    handleMapClick({type, coords}) {
      if (this.$refs.routing?.handleMapClickFromMap) {
        this.$refs.routing.handleMapClickFromMap(type, coords);
      } else {
        console.warn("Reference to RoutingPanel or method handleMapClickFromMap is missing");
      }
    },
    handlePoiSelectedFrom3D({poiId}) {
      this.selectedPoiId = poiId;
      const feature = this.loadedPois.features.find((f) => f.properties.id === poiId);
      if (feature) {
        const [lng, lat] = feature.geometry.coordinates;
        const center = googleMaps.transformFromLatLng({lat, lng});
        const view = basemap.map.getView();
        view.setCenter(center);
        view.setZoom(17);
      }
    },
    onForceCloseWeather() {
      const ref = this.$refs.weatherMtk;
      if (!ref) return;

      if (this.weatherLayerActive && typeof ref.disableWeatherLayer === "function") {
        ref.disableWeatherLayer();
      }

      this.weatherLayerActive = false;
      this.setMtkFlag(true);

      const v = ref.getCurrentView?.();
      if (v) {
        sessionStorage.setItem("mtkLastView", JSON.stringify(v));
        this.setUrlLocation(v.lat, v.lng, v.zoom, {keepMtk: true});
      }
    },
    onForceClose3D() {
      const v = this.$refs.weatherMtk?.getCurrentView?.();
      if (v) this.onWeatherMapClosed(v);
      this.showMap3D = false;
      this.showWeatherMtk = false;
      this.setMtkFlag(false);
      this.close3DOnNextService = false;
    },
    onTriggerGeolocation() {
      this.$refs.weatherMtk?.triggerGeolocation?.();
    },
    async getMtkSnapshot({pxWidth, pxHeight}) {
      if (window._weatherMTK?.snapshot3DForPrint) {
        return await window._weatherMTK.snapshot3DForPrint({pxWidth, pxHeight});
      }

      const canvas = this.$refs.weatherMtk?.$el?.querySelector("canvas");
      if (!canvas) throw new Error("canvas MTK.");

      await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

      const srcW = canvas.width;
      const srcH = canvas.height;

      const out = document.createElement("canvas");
      out.width = pxWidth;
      out.height = pxHeight;
      const ctx = out.getContext("2d");

      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, out.width, out.height);

      const scale = Math.min(out.width / srcW, out.height / srcH);
      const drawW = Math.round(srcW * scale);
      const drawH = Math.round(srcH * scale);
      const dx = Math.floor((out.width - drawW) / 2);
      const dy = Math.floor((out.height - drawH) / 2);

      try {
        ctx.drawImage(canvas, 0, 0, srcW, srcH, dx, dy, drawW, drawH);
        return out.toDataURL("image/png");
      } catch (e) {
        console.warn("[getMtkSnapshot]", e);
        throw e;
      }
    },

    // async getMtkSnapshot({ pxWidth, pxHeight }) {
    //   if (window._weatherMTK?.snapshot3DForPrint) {
    //     return await window._weatherMTK.snapshot3DForPrint({
    //       pxWidth,
    //       pxHeight,
    //     });
    //   }

    //   const canvas = this.$refs.weatherMtk?.$el?.querySelector("canvas");

    //   if (!canvas) throw new Error("Nu găsesc canvas-ul MTK.");

    //   await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

    //   const srcW = canvas.width;
    //   const srcH = canvas.height;

    //   const out = document.createElement("canvas");
    //   out.width = pxWidth;
    //   out.height = pxHeight;
    //   const ctx = out.getContext("2d");

    //   ctx.fillStyle = "#fff";
    //   ctx.fillRect(0, 0, out.width, out.height);

    //   const scale = Math.min(out.width / srcW, out.height / srcH);
    //   const drawW = Math.round(srcW * scale);
    //   const drawH = Math.round(srcH * scale);
    //   const dx = Math.floor((out.width - drawW) / 2);
    //   const dy = Math.floor((out.height - drawH) / 2);

    //   ctx.drawImage(canvas, 0, 0, srcW, srcH, dx, dy, drawW, drawH);
    //   return out.toDataURL("image/png");
    // },
  },
};
</script>
<style scoped>
.rotate-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background: rgba(122, 121, 121, 0.749);
  display: flex;
  align-items: center;
  justify-content: center;
}

.rotate-box {
  max-width: 320px;
  background: #ecf0f3;
  border-radius: 18px;
  padding: 20px 24px;
  text-align: center;
  font-family: Quicksand, sans-serif;
  border: 1px solid #a9a9a9;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.35);
}

.rotate-box p {
  margin: 8px 0 0;
  font-size: 15px;
  color: #444;
  line-height: 1.4;
}

.rotate-icon {
  font-size: 36px;
  margin-bottom: 6px;
}

.landscape-block #map .maplibregl-ctrl {
  display: none !important;
}

.landscape-block .setting-buttons-component,
.landscape-block .setting-buttons,
.landscape-block .map3d-button,
.landscape-block .map-3d-toggle {
  display: none !important;
}
</style>
